<section
    id="lead-list-container"
    [ngClass]="{
        'p-3 lead-list-container w-100 position-relative': true,
        'mv-100': leadListState == LEAD_LIST_STATE.LOADING,
    }"
>
    <!-- Show Lead View Modal -->
    <div
        class="position-absolute top-0 start-0 h-100 w-100 lead-view-modal d-flex justify-content-center align-items-center"
        *ngIf="leadViewToggle"
    >
        <div class="p-4 my-auto rounded-3">
            <div class="w-100 float-end">
                <button
                    class="btn btn-transparent p-1 float-end"
                    (click)="closeLeadView()"
                >
                    <img
                        src="/img/icons/xmark-circle.svg"
                        alt="Close View Screen"
                    />
                </button>
            </div>
            <p class="fs-2 text-break">
                {{ leadViewData['first_name'] }} {{ leadViewData['last_name'] }}
            </p>
            <div class="d-flex gap-3 mb-3" *ngIf="leadViewData['designation'] || leadViewData['company']">
                <img src="/img/icons/suitcase.svg" alt="designation" />
                <p class="my-auto text-break">
                    {{ leadViewData['designation'] || '' }}
                    <span *ngIf="leadViewData['designation'] && leadViewData['company']"> at </span>
                    {{ leadViewData['company'] || '' }}
                </p>
            </div>
            <div class="d-flex gap-3 mb-3" *ngIf="leadViewData['phone']">
                <img
                    src="/img/icons/phone-arrow-right.svg"
                    alt="phone number"
                />
                <a [href]="'tel:' + leadViewData['phone']">
                    {{ leadViewData['phone'] }}
                </a>
            </div>
            <div class="d-flex gap-3 mb-3">
                <img src="/img/icons/envelope.svg" alt="email address" />
                <a class="text-break" [href]="'mailto:' + leadViewData['email']">
                    {{ leadViewData['email'] }}
                </a>
            </div>
            <p class="mb-0 text-grey">
                Added on {{ leadViewData['created'] | date: 'dd/MM/yyyy' }}
            </p>
        </div>
    </div>

    <div>
        <div [ngClass]="{ 'height-80': leadListState == LEAD_LIST_STATE.ERROR }">
            <!-- Heading | filtering buttons -->
            <div class="d-flex justify-content-between pb-3 position-relative">
                <p class="fs-3 mb-0">My Contacts</p>
                <div class="d-flex gap-3">
                    <div *ngIf="isAdminUser">
                        <button
                            class="btn btn-transparent"
                            (click)="toggleAdminDropdown()"
                            [disabled]="leadListState == LEAD_LIST_STATE.ERROR"
                        >
                            <img
                                width="20"
                                height="20"
                                [src]="'/img/icons/phonebook.svg'"
                                alt="FilterIcon"
                            />
                        </button>
                        <div
                            *ngIf="isAdminDropdownOpen"
                            class="shadow filter-container rounded-3 position-absolute top-0 end-0 mt-5 bg-light"
                        >
                            <button
                                class="btn btn-transparent w-100 d-flex gap-3 active"
                                (click)="handleAdminContactList(CONTACT_TYPE.ORGANIZATION_CONTACTS)"
                                [ngClass]="{active: adminContactTypeFilter === CONTACT_TYPE.ORGANIZATION_CONTACTS}"
                            >
                                <p class="mb-0">{{ CONTACT_TYPE.ORGANIZATION_CONTACTS }}</p>
                                <img
                                    src="/img/icons/check-blue.svg"
                                    alt="LatestFirstFilter"
                                />
                            </button>
                            <button
                                class="btn btn-transparent w-100 d-flex gap-3 active"
                                (click)="handleAdminContactList(CONTACT_TYPE.MY_CONTACTS)"
                                [ngClass]="{active: adminContactTypeFilter === CONTACT_TYPE.MY_CONTACTS}"
                            >
                                <p class="mb-0">{{ CONTACT_TYPE.MY_CONTACTS }}</p>
                                <img
                                    src="/img/icons/check-blue.svg"
                                    alt="LatestFirstFilter"
                                />
                            </button>
                        </div>
                    </div>
                    <div>
                        <button
                            class="btn btn-transparent"
                            (click)="toggleFilter()"
                            [disabled]="leadListState == LEAD_LIST_STATE.ERROR"
                        >
                            <img
                                width="20"
                                height="20"
                                [src]="
                                    filter === CONTACT_LIST_FILTER.ALPHABET_ASCENDING
                                        ? '/img/icons/sort-icon.svg'
                                        : '/img/icons/sort-icon-active.svg'
                                "
                                alt="FilterIcon"
                            />
                        </button>
                        <!-- Disable the filter button when the toggle is disabled or when the lead state is in the loading statem -->
                        <div *ngIf="filterToggle && leadListState !== LEAD_LIST_STATE.LOADING"
                            class="shadow filter-container rounded-3 position-absolute top-0 end-0 mt-5 bg-light"
                        >
                            <button
                                class="btn btn-transparent w-100 d-flex gap-3 active"
                                (click)="updateListFilter(LEAD_LIST_FILTER_STATE.CALENDAR,false)"
                                [ngClass]="{ active: filter === CONTACT_LIST_FILTER.CALENDAR_DESCENDING }"
                            >
                                <p class="mb-0">Latest First</p>
                                <img src="/img/icons/check-blue.svg" alt="LatestFirstFilter" />
                            </button>
                            <button
                                [ngClass]="{ active: filter === CONTACT_LIST_FILTER.CALENDAR_ASCENDING }"
                                class="btn btn-transparent w-100 d-flex gap-3"
                                (click)="updateListFilter(LEAD_LIST_FILTER_STATE.CALENDAR,true)"
                            >
                                <p class="mb-0">Oldest First</p>
                                <img src="/img/icons/check-blue.svg" alt="OldestFirstFilter" />
                            </button>
                            <button
                                [ngClass]="{ active: filter === CONTACT_LIST_FILTER.ALPHABET_ASCENDING }"
                                class="btn btn-transparent w-100 d-flex gap-3"
                                (click)="updateListFilter(LEAD_LIST_FILTER_STATE.ALPHABET,true)"
                            >
                                <p class="mb-0">A-Z</p>
                                <img src="/img/icons/check-blue.svg" alt="active filter" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Loading State for lead list -->
            <app-skeleton-loader-lead-list
                *ngIf="leadListState == LEAD_LIST_STATE.LOADING"
            ></app-skeleton-loader-lead-list>

            <!-- Error state for lead list -->
            <div class="d-flex flex-column align-items-center position-absolute top-50 start-50 translate-middle w-100 text-center px-3" *ngIf="leadListState == LEAD_LIST_STATE.ERROR">
                <p class="text-grey fs-2 mb-0">
                    {{ navigator.onLine ? 'Unable to load contacts' : 'You\'re currently offline' }}
                </p>

                <div *ngIf="navigator.onLine">
                    <div *ngIf="(isLoggedIn$ | async)">
                        <p class="text-grey">
                            Trouble loading your contact list. Please refresh or try
                            again later.
                        </p>
                        <button
                            class="btn btn-transparent w-100 text-center"
                            (click)="handleRefreshOnLeadList()"
                        >
                            <img
                                src="/img/icons/rotate-arrow-right.svg"
                                alt="RefreshButton"
                            />
                            <span class="text-primary-blue ms-2">Refresh</span>
                        </button>
                    </div>
                    <p class="text-grey" *ngIf="!(isLoggedIn$ | async)">
                        Try logging in
                    </p>
                </div>
                <p class="text-grey" *ngIf="!navigator.onLine">
                    Connect to internet to load contacts
                </p>
                

            </div>

            <div class="d-flex flex-column align-items-center position-absolute top-50 start-50 translate-middle w-100 text-center px-3" *ngIf="isLeadCountZero">
                <p class="text-grey fs-2 mb-0 fw-500">
                    No Contacts Found
                </p>
            </div>

            <div class="position-relative contact-list-item-container">
                <!-- Filter by alphabet -->
                <div class="d-flex gap-2" *ngIf="leadListState === LEAD_LIST_STATE.FETCHED && leadListFilterState === LEAD_LIST_FILTER_STATE.ALPHABET">
                    <div class="d-flex flex-column gap-3 w-100 overflow-scroll">
                        <div class="d-flex flex-column" *ngFor="let letter of objectKeys(leadData?.[LEAD_LIST_FILTER_STATE.ALPHABET])">
                            <div
                                class="contact-item-heading p-3"
                                [id]="'alphabet-' + letter"
                                #alphabetElement
                            >
                                <p class="mb-0 text-uppercase">{{ letter }}</p>
                            </div>
                            <button
                                class="contact-item p-3 d-flex btn btn-transparent text-start"
                                *ngFor="let lead of leadData?.[LEAD_LIST_FILTER_STATE.ALPHABET]?.[letter]"
                                (click)="openLeadView(lead)"
                                [attr.data-lead-id]="lead?.id"
                                #contactItemsElements
                            >
                                <div class="my-auto me-3">
                                    <div class="rounded-circle bg-light-grey d-flex justify-content-center align-items-center">
                                        <p class="mb-0">
                                            {{ lead?.first_name.charAt(0).toUpperCase() }}{{ lead?.last_name.charAt(0).toUpperCase() }}
                                        </p>
                                    </div>
                                </div>
                                <div class="d-flex flex-column my-auto">
                                    <p class="text-dark mb-0">
                                        {{ lead?.first_name }} {{ lead?.last_name }}
                                    </p>
                                    <p class="text-grey mb-0">
                                        {{ lead?.company }}
                                    </p>
                                </div>
                            </button>
                        </div>
                    </div>

                    <div class="d-flex flex-column justify-content-between alphabet-filter-container">
                        <button
                            class="btn btn-outline-primary scroll-view py-0 px-1 border-0 rounded-circle"
                            *ngFor="let letter of alphabet"
                            (click)="scrollToAlphabet(letter)"
                        >
                            {{ letter }}
                        </button>
                    </div>
                </div>

                <!-- Filter by calendar -->
                <div
                    class="d-flex flex-column gap-3 pb-5 overflow-scroll"
                    *ngIf="leadListState === LEAD_LIST_STATE.FETCHED && leadListFilterState === LEAD_LIST_FILTER_STATE.CALENDAR"
                >
                    <div class="d-flex flex-column" *ngFor="let calendarItem of objectKeys(leadData?.[LEAD_LIST_FILTER_STATE.CALENDAR])">
                        <div class="contact-item-heading p-3">
                            <p class="mb-0 text-uppercase"> {{ calendarItem }} </p>
                        </div>
                        <button
                            class="contact-item p-3 d-flex btn btn-transparent text-start"
                            (click)="openLeadView(lead)" [attr.data-lead-id]="lead?.id"
                            *ngFor="let lead of leadData?.[LEAD_LIST_FILTER_STATE.CALENDAR]?.[calendarItem]"
                        >
                            <div class="my-auto me-3">
                                <div class="rounded-circle bg-light-grey d-flex justify-content-center align-items-center">
                                    <p class="mb-0">
                                        {{ lead?.first_name.charAt(0).toUpperCase() }}{{ lead?.last_name.charAt(0).toUpperCase() }}
                                    </p>
                                </div>
                            </div>
                            <div class="d-flex flex-column my-auto">
                                <p class="text-dark mb-0">
                                    {{ lead?.first_name }} {{ lead?.last_name }}
                                </p>
                                <p class="text-grey mb-0"> {{ lead?.company }} </p>
                            </div>
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- Add bottom navigation menu bar -->
        <app-bottom-nav>
        </app-bottom-nav>
    </div>
</section>
